import './style.scss';

// safariでのタップ調整（safariのみタップが反応しないブロックの対応：カード、ボックスのホバー）
(function () {
    // タッチ端末かつ “実ホバーなし” 環境に限定
    var isTouch = ('ontouchstart' in window) || (navigator.maxTouchPoints > 0);
    var noRealHover = window.matchMedia ? window.matchMedia('(hover: none)').matches : true;
    if (!isTouch || !noRealHover) return;

    // 多重登録ガード
    if (window.__lpcb_touchstart_injected__) return;
    window.__lpcb_touchstart_injected__ = true;

    // Safari/iOS向けの no-op touchstart（キャプチャ＋パッシブで安全）
    document.addEventListener('touchstart', function () {}, { capture: true, passive: true });
})();
